import { combineReducers } from "redux";

const apiDataReducer = (state = [], action) => {
  switch (action.type) {
    case "API_DATA":
      return action.payload;
    default:
      return state;
  }
};

const isLoggedInReducer = (state = null, action) => {
  switch (action.type) {
    case "LOGGED":
      return action.payload;
    default:
      return state;
  }
};

const userReducer = (state = [], action) => {
  switch (action.type) {
    case "CURRENT_USER":
      return action.payload;
    default:
      return state;
  }
};

const editorReducer = (state = [], action) => {
  switch (action.type) {
    case "EDITOR":
      return action.payload;
    default:
      return state;
  }
};

const dropReducer = (state = true, action) => {
  switch (action.type) {
    case "DROP":
      return action.payload;
    default:
      return state;
  }
};

const ascReducer = (state = [], action) => {
  switch (action.type) {
    case "ASC_DATA":
      return action.payload;
    default:
      return state;
  }
};

const sheetReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_SHEET":
      return action.payload;
    default:
      return state;
  }
};
const ascIdReducer = (state = null, action) => {
  switch (action.type) {
    case "ASC_ID":
      return action.payload;
    default:
      return state;
  }
};
export default combineReducers({
  apiData: apiDataReducer,
  user: userReducer,
  isLoggedIn: isLoggedInReducer,
  editor: ascReducer,
  Listsheet: sheetReducer,
  useEditor: editorReducer,
  ascId: ascIdReducer,
  drop: dropReducer,
});
